module.exports = __webpack_public_path__ + "img/conimg3-04.883d21ed.png";